export default __webpack_public_path__ + "static/media/007-cathedral of saint basil.1b2b1352.svg";